import {CloseButton} from './CloseButton'
import {DrawerFooter} from './Footer'
import {DrawerHeader} from './Header'
import {MobileDrawerBase} from './MobileDrawer'
import {MobileDrawerSimple} from './Simple'

export const MobileDrawer = Object.assign(MobileDrawerSimple, {
  Base: MobileDrawerBase,
  CloseButton,
  Header: DrawerHeader,
  Footer: DrawerFooter,
})
